// @ts-strict-ignore
import { zip } from 'lodash-es';

//Assuming tabs to separate columns and newlines to separate rows
export function createValueMatrix(values: string, allowEmptyCells = false, transposeSingleColumn = false): string[][] {
  const rows: string[] = values.split(/\r?\n/);
  let rowItems: string[][] = [];
  rows.forEach((row) => {
    if (row || allowEmptyCells) {
      //when splitting, we could get an empty string at the end
      const rowItem: string[] = [];
      const cells: string[] = row.split('\t');
      cells.forEach((cellValue) => {
        if (cellValue || allowEmptyCells) {
          rowItem.push(cellValue);
        }
      });
      rowItems.push(rowItem);
    }
  });
  if (transposeSingleColumn && _isSingleColumnMatrix(rowItems)) {
    rowItems = _transposeMatrix(rowItems);
  }
  return rowItems;
}

export function isSingleValueMatrix(matrix: string[][]): boolean {
  return _isSingleRowMatrix(matrix) && _isSingleColumnMatrix(matrix);
}

function _isSingleColumnMatrix(matrix: string[][]): boolean {
  return matrix.every((r) => r.length === 1);
}

function _isSingleRowMatrix(matrix: string[][]): boolean {
  return matrix.length === 1;
}

function _transposeMatrix(matrix: string[][]): string[][] {
  return zip(...matrix);
}
